<template>
  <span style="padding-top:1rem; width:2.5rem; height:2.5rem;" id="Spinner"></span>
</template>
<script>
/* eslint-disable */
import lottie from 'lottie-web';
import data from '../assets/images/loaders/data.json';
export default {
  data() {
    return {
      animationData: data,
    }
  },
  mounted() {
    lottie.loadAnimation({
      container: document.getElementById('Spinner'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      // path: '../assets/images/loaders/data.json'
      animationData: this.animationData, // the path to the animation json
     });
  },
};
</script>